/**
 * Resultsgate API
 * Open API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ExtractionMethodListItem { 
    createdBy?: string;
    createdOn?: string;
    updatedBy?: string;
    updatedOn?: string;
    categories?: string;
    description?: string;
    id?: number;
    name?: string;
}

